import { MfeLoad } from '@carvana/microfrontend';
import { MfeReactComponent } from '@carvana/microfrontend-react';
import { useContext, useEffect } from 'react';
import { getMfeCacheBuster } from '@/common/MicroFrontEnds';
import { commonEnvironment } from '~/constants/environment';
import StaticContext from '~/context/common/StaticContext';
import { useClientSide } from '~/hooks/common';
import { wait } from '~/utilities';
import { withErrorBoundary } from '~/utilities/ErrorBoundary';

function PageFooter() {
  const { removeFooter } = useContext(StaticContext);
  const isClientSide = useClientSide();

  useEffect(() => {
    if (removeFooter) return;

    wait(100).then(() => {
      void MfeLoad({
        files: [
          [
            'FooterModule',
            [
              {
                component: 'default',
                browser: true,
                default: {
                  file: 'index.js',
                  manifest: `${
                    process.env.CVNA_APP_CDN_URL
                  }/footer/module/assets-manifest.json?v=${getMfeCacheBuster()}`
                }
              }
            ]
          ]
        ]
      });
    });
  }, [removeFooter]);

  if (removeFooter) return null;

  return isClientSide ? (
    <MfeReactComponent
      component="default"
      module="FooterModule"
      environment={commonEnvironment}
      withoutProvider
    />
  ) : null;
}

export default withErrorBoundary(PageFooter);
